module.exports = __webpack_public_path__ + "static/img/qrCode1.676eba80.png";